import { Token } from "@siteimprove/alfa-css";
import { Iterable } from "@siteimprove/alfa-iterable";
import { Option } from "@siteimprove/alfa-option";
import { Parser } from "@siteimprove/alfa-parser";
import { Specificity } from "../../specificity.js";
import { WithName } from "../selector.js";
const { map, right } = Parser;
/**
 * {@link https://drafts.csswg.org/selectors/#class-selector}
 *
 * @public
 */
export class Class extends WithName {
    static of(name) {
        return new Class(name);
    }
    _key;
    constructor(name) {
        super("class", name, Specificity.of(0, 1, 0));
        this._key = Option.of(this);
    }
    matches(element) {
        return Iterable.includes(element.classes, this._name);
    }
    equals(value) {
        return value instanceof Class && value._name === this._name;
    }
    *[Symbol.iterator]() {
        yield this;
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
    toString() {
        return `.${this._name}`;
    }
}
/**
 * @public
 */
(function (Class) {
    function isClass(value) {
        return value instanceof Class;
    }
    Class.isClass = isClass;
    /**
     * @internal
     */
    Class.parse = map(right(Token.parseDelim("."), Token.parseIdent()), (ident) => Class.of(ident.value));
})(Class || (Class = {}));
//# sourceMappingURL=class.js.map